import { ConfirmDialog } from '@/shared/ui/confirm-dialog'
import { toast } from '@/shared/ui/toast'
import { useDeleteInvoice } from '../api/mutations'

interface DeleteInvoiceDialogProps {
  invoice: { id: string; number: string }
  open: boolean
  onClose: () => void
  /** Куда уйти после удаления (со страницы счёта — в список). */
  onDeleted?: () => void
}

export function DeleteInvoiceDialog({
  invoice,
  open,
  onClose,
  onDeleted,
}: DeleteInvoiceDialogProps) {
  const del = useDeleteInvoice(invoice.id)
  return (
    <ConfirmDialog
      open={open}
      title="Удалить счёт?"
      confirmLabel="Удалить"
      pending={del.isPending}
      onClose={onClose}
      onConfirm={() =>
        del.mutate(undefined, {
          onSuccess: () => {
            toast.success('Счёт удалён')
            onClose()
            onDeleted?.()
          },
          onError: () => toast.error('Не удалось удалить счёт'),
        })
      }
    >
      Счёт {invoice.number}, его файл, документы и обсуждение удалятся без возврата.
    </ConfirmDialog>
  )
}
